import React, { useEffect, useState } from 'react';
import MobileProfileTopNavigation from './MobileProfileTopNavigation';
import PersonalSettingsSection from '../../PageComponent/ProfilePage/Personalsettings';

function MobileProfileSubSettings() {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
 
  return (
    <div className='text-coalBlack pt-12'>
        <MobileProfileTopNavigation pageTitle={'Settings'} />
        <PersonalSettingsSection />
    </div>
  );
}

export default MobileProfileSubSettings;
